import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { megamenuIcon, userSessionIcon } from './svgIcons';

import Logo from './Logo';
import UserHeadingSession from './UserHeadingSession';
import ShoppingBag from './ShoppingBag';
import Dropdown from './HeaderWeb/Dropdown';
import Overlay from './Overlay';
import CloseSessionBtn from './CloseSessionBtn';
import Megamenu from './Megamenu/MegamenuContainer';
import NewMegamenu from "./Megamenu/NewMegamenuContainer"
import WishList from './WishList';

import CommonUtil from '../../../utils/commonUtil';
import SearchBar from './SearchBar';

const channel = CommonUtil.getChannel();

@connect(
  store => ({
    user: store.user.data,
  }),
)

class NewHeaderBrand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aboveUserBtn: false,
      clickOnMegamenu: false,
    };
  }

  handleOnHoverUserBtn = statusHover => this.setState({ ...this.state, aboveUserBtn: statusHover });

  handleClickMegamenu = () => this.setState({ ...this.state, clickOnMegamenu: !this.state.clickOnMegamenu });

  shouldShowMenu = () => this.handleClickMegamenu();

  render() {
    const {
      megamenu,
      userDataDropdownLogged,
      userDataDropdownGuest,
      handleLogoutWithAuth0, user = {},
      handleLoginWithAuth0,
    } = this.props;

    const { aboveUserBtn, clickOnMegamenu } = this.state;
    const result = user?.result || {};
    const { lastName, firstName, profileId = false, emailId } = result;

    const infoSession = {
      name: firstName,
      lastNameFather: lastName,
      hasActiveSession: profileId,
    };

    const userDataDropdown = infoSession.hasActiveSession
      ? userDataDropdownLogged
      : userDataDropdownGuest;

    return (
      <Fragment>
        <div className={'headerBrandContainer'}>
          <div className={'headerBrand centerHeader'}>
            <Logo />

            <div className="megaMenuButton" onClick={this.handleClickMegamenu}>
              <span>{ megamenuIcon }</span>
              <span> Categorías</span>
            </div>

            {
              clickOnMegamenu && (
                <NewMegamenu
                  showMegaMenu={clickOnMegamenu}
                  handleClickMegamenu={this.handleClickMegamenu}
                  megamenu={megamenu}
                />
              )
            }

            <div className={'typeaheadContainer'} style={{ display: 'flex', placeContent: 'center' }}>
              <SearchBar />
            </div>

            <div className="userOptionsMenu">
              <div
                className="itemLink dinamicItemContainerForDropdown"
                style={{ paddingRight: 0 }}
              >
                <span
                  className={`aligmentUserOptions ${aboveUserBtn ? 'bgUserSesionDesk' : 'bgUserInactiveSesionDesk'}`}
                  style={{ color: '#fafafa', cursor: 'pointer', justifyContent: 'center' }}
                  onMouseEnter={() => this.handleOnHoverUserBtn(true)}
                  onMouseLeave={() => this.handleOnHoverUserBtn(false)}
                >
                  { userSessionIcon(channel) }
                  <div className="userOptionsName">
                    { infoSession.hasActiveSession ? `${infoSession.name} ${infoSession.lastNameFather}` : 'Iniciar sesión' }
                  </div>
                  <span className="chevron top" style={{ visibility: aboveUserBtn ? 'visible' : 'hidden' }} />
                </span>
                {
                  aboveUserBtn && (
                    <Dropdown
                      handleOnHoverBtn={this.handleOnHoverUserBtn}
                      infoSession={infoSession}
                      dataList={userDataDropdown}
                      aboveUserBtn={aboveUserBtn}
                      stylePosition={'-22px'}
                    >
                      {
                        <Fragment>
                          <UserHeadingSession
                            classname={`${infoSession.hasActiveSession && 'activeSessionDesk'}`}
                            customer={infoSession}
                            handleLogin={handleLoginWithAuth0}
                          />
                          {
                            infoSession.hasActiveSession && (
                              <CloseSessionBtn handleLogout={handleLogoutWithAuth0} email={emailId} />
                            )
                          }
                        </Fragment>
                      }
                    </Dropdown>
                  )
                }
              </div>
              <WishList hasActiveSession={infoSession.hasActiveSession} />
              <div>
                <ShoppingBag />
              </div>

            </div>

          </div>
          { (aboveUserBtn || clickOnMegamenu)
            &&
            <Overlay
              handleActionOverlay={this.shouldShowMenu}
              styles={{
                styleTop: clickOnMegamenu ? '0' : '112px',
                zIndex: clickOnMegamenu ? 9 : 2,
              }}
            />
          }
        </div>
      </Fragment>
    );
  }
}

export default NewHeaderBrand;
